<template>
  <div>
    <span v-if="!editable">{{ initialValue }}</span>
    <input v-else :id="id" ref="input" v-bind="$attrs" class="h-10 px-3 py-2 border w-full" :class="{ 'border-red-400': inputError }" :type="type" :value="value" @input="$emit('input', $event.target.value)" autocomplete="false">
    <div v-if="inputError" class="text-red-500 text-sm mt-2 leading-tight">{{ inputError }}</div>
  </div>
</template>

<script>
  export default {
    inheritAttrs: false,
    props: {
      id: {
        type: String,
        default() {
          return `text-input-${this._uid}`
        },
      },
      type: {
        type: String,
        default: 'text',
      },
      editable: {
        type: Boolean,
        default: true
      },
      value: null,
      initialValue: null,
      inputError: String
    },
    methods: {
      focus() {
        this.$refs.input.focus()
      },
      select() {
        this.$refs.input.select()
      },
      setSelectionRange(start, end) {
        this.$refs.input.setSelectionRange(start, end)
      },
    },
  }
</script>
